import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Auth\RedirectToWorkOSController::__invoke
* @see app/Http/Controllers/Auth/RedirectToWorkOSController.php:17
* @route '/sso'
*/
export const redirect = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: redirect.url(options),
    method: 'post',
})

redirect.definition = {
    methods: ["post"],
    url: '/sso',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\RedirectToWorkOSController::__invoke
* @see app/Http/Controllers/Auth/RedirectToWorkOSController.php:17
* @route '/sso'
*/
redirect.url = (options?: RouteQueryOptions) => {
    return redirect.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\RedirectToWorkOSController::__invoke
* @see app/Http/Controllers/Auth/RedirectToWorkOSController.php:17
* @route '/sso'
*/
redirect.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: redirect.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\HandleWorkOSCallbackController::__invoke
* @see app/Http/Controllers/Auth/HandleWorkOSCallbackController.php:19
* @route '/sso/callback'
*/
export const callback = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: callback.url(options),
    method: 'get',
})

callback.definition = {
    methods: ["get","head"],
    url: '/sso/callback',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\HandleWorkOSCallbackController::__invoke
* @see app/Http/Controllers/Auth/HandleWorkOSCallbackController.php:19
* @route '/sso/callback'
*/
callback.url = (options?: RouteQueryOptions) => {
    return callback.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\HandleWorkOSCallbackController::__invoke
* @see app/Http/Controllers/Auth/HandleWorkOSCallbackController.php:19
* @route '/sso/callback'
*/
callback.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: callback.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\HandleWorkOSCallbackController::__invoke
* @see app/Http/Controllers/Auth/HandleWorkOSCallbackController.php:19
* @route '/sso/callback'
*/
callback.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: callback.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\ShowWorkOSErrorController::__invoke
* @see app/Http/Controllers/Auth/ShowWorkOSErrorController.php:14
* @route '/sso/error'
*/
export const error = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: error.url(options),
    method: 'get',
})

error.definition = {
    methods: ["get","head"],
    url: '/sso/error',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\ShowWorkOSErrorController::__invoke
* @see app/Http/Controllers/Auth/ShowWorkOSErrorController.php:14
* @route '/sso/error'
*/
error.url = (options?: RouteQueryOptions) => {
    return error.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\ShowWorkOSErrorController::__invoke
* @see app/Http/Controllers/Auth/ShowWorkOSErrorController.php:14
* @route '/sso/error'
*/
error.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: error.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\ShowWorkOSErrorController::__invoke
* @see app/Http/Controllers/Auth/ShowWorkOSErrorController.php:14
* @route '/sso/error'
*/
error.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: error.url(options),
    method: 'head',
})

const sso = {
    redirect: Object.assign(redirect, redirect),
    callback: Object.assign(callback, callback),
    error: Object.assign(error, error),
}

export default sso